import { apiUrl } from './api/client'

// The fleet photo, served by GET /api/aircraft/:registration/picture.
// pictureUpdatedAt is the upload time, so a new photo is a new URL and the
// long private cache never shows a stale one. null when there is none.
export function aircraftPictureUrl(registration: string, pictureUpdatedAt: string | null): string | null {
  if (!pictureUpdatedAt) return null
  return apiUrl(`/api/aircraft/${encodeURIComponent(registration)}/picture?v=${Date.parse(pictureUpdatedAt)}`)
}
